import type { Project } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn } from "@tudigo-monorepo/core-tudigo-theme";
import {
  ComparatorGrid,
  ComparatorGridColumn,
  ComparatorSelectedItem,
  ComparatorSelectionList,
  useComparatorScroller,
} from "@tudigo-monorepo/web-tudigo-comparator";
import { UI_PROJECTS_COMPARATOR_MODAL_PROJECT_DELETED } from "@tudigo-monorepo/web-tudigo-tracking";

import {
  ProjectCard,
  ProjectCardAvatar,
  ProjectCardAvatarFallback,
  ProjectCardHeader,
  ProjectCardLabel,
} from "../../../../../shared-external/components/project-card/project-card";
import { useProjectsComparatorCustomerTracking } from "../../../hooks/use-projects-comparator-customer-tracking";

export function ProjectsComparatorStickySelectionList() {
  const {
    state: { scrollPosition },
  } = useComparatorScroller();

  const { customerTrackComparator } = useProjectsComparatorCustomerTracking();

  return (
    <ComparatorGrid className="m-0 h-full w-auto p-0">
      <ComparatorSelectionList>
        {(project: Project, index) => (
          <ComparatorGridColumn
            key={project.id}
            className="h-full min-w-[338px]"
          >
            <ComparatorSelectedItem
              item={project}
              className={cn(
                "h-full min-w-[338px] opacity-100 transition-opacity duration-200",
                scrollPosition > index && "opacity-0",
              )}
              onUpdate={() => {
                customerTrackComparator(
                  UI_PROJECTS_COMPARATOR_MODAL_PROJECT_DELETED,
                  {
                    project_id: project.id,
                    project_name: project.content?.name,
                  },
                );
              }}
            >
              <ProjectCard
                project={project}
                className="h-full bg-transparent shadow-none"
              >
                <ProjectCardHeader className="mb-0 h-full w-full rounded-b-lg">
                  <ProjectCardAvatar />
                  <ProjectCardAvatarFallback />
                  <ProjectCardLabel className="max-w-52 text-base font-medium" />
                </ProjectCardHeader>
              </ProjectCard>
            </ComparatorSelectedItem>
          </ComparatorGridColumn>
        )}
      </ComparatorSelectionList>
    </ComparatorGrid>
  );
}
